import { createFeature } from '@ngrx/store';

import { surveyManagementReducer } from './survey-management.reducer';

export const surveyManagementFeatureKey = 'surveyManagement';

export const surveyManagementFeature = createFeature({
  name: surveyManagementFeatureKey,
  reducer: surveyManagementReducer,
});
